import React, { Component } from 'react';

class RangeCompontent extends Component {
	render() {
		return (
			<div>
				{this.props.text}
				<br />
				<button
					disabled={this.props.value <= (this.props.min !== undefined ? this.props.min : 0)}
					onClick={(e) => this.props.callback(this.props.name, Math.max(0, this.props.value - 1))}
				>-</button>
				<input
					style={{ minWidth:"300px", maxWidth: "600px" }}
					type="range"
					id={this.props.name}
					name={this.props.name}
					checked={this.props.checked}
					min={this.props.min !== undefined ? this.props.min : 0}
					max={this.props.max}
					value={this.props.value}
					step="1"
					onChange={(e) => {
						let val = parseInt(e.target.value);
						if (this.props.max_add) {
							if (val - this.props.value > this.props.max_add) {
								val = this.props.value + this.props.max_add;
							}
						}
						this.props.callback(this.props.name, val)
					}
					}
				/>
				<button
					disabled={this.props.value >= this.props.max}
					onClick={(e) => this.props.callback(this.props.name, Math.min(this.props.max, this.props.value + 1))}
				>+</button>
			</div>
		);
	}
}

export default RangeCompontent;